import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { getReasonForVisitLabel } from '@provider-directory/components/availability/availability.model';
import { useSearch } from '@provider-directory/contexts/ProviderSearchContext';

interface FilterBannerProps {
  onSearch?: () => void;
  reasonForVisit?: string | null;
  providerGroup?: string | null;
}

export const FilterBanner = ({
  reasonForVisit,
  providerGroup,
}: FilterBannerProps): ReactElement | null => {
  const { t } = useTranslation();
  const { search } = useSearch();

  if (!reasonForVisit && !providerGroup) {
    return null; // Return empty if no reason for visit or provider group is provided
  }
  return (
    <div
      data-testid={'filter-banner'}
      className={
        'mb-4 flex items-center justify-between rounded-lg bg-primary-200 p-6'
      }
    >
      <span className={'text-body-medium font-semibold'}>
        {reasonForVisit
          ? t('searchResults.rfvFilter', {
              reasonForVisit: getReasonForVisitLabel(reasonForVisit, t),
            })
          : t(`providerGroups.${providerGroup ?? ''}`)}
      </span>
      <button
        className={'text-body-medium-medium'}
        onClick={() => {
          search({
            key: reasonForVisit ? 'reasonForVisit' : 'providerGroup',
            option: null,
          });
        }}
      >
        {t('clear')}
      </button>
    </div>
  );
};
